// /src/firebase.jsx (Updated for Security)

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration is now read from environment variables
export const firebaseConfig = {
  apiKey: "AIzaSyA2pkzjem6Mq375rwCvA_RB30KiaxK5vB4",
  authDomain: "nammaapp-12ad8.firebaseapp.com",
  projectId: "nammaapp-12ad8",
  storageBucket: "nammaapp-12ad8.firebasestorage.app",
  messagingSenderId: "830465293241",
  appId: "1:830465293241:web:bb129777d9a6bfd0fad468",
  measurementId: "G-KEK3679XG8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);